console.log('init Proteus Treatments -- 1.06');

document.addEventListener("cart:change", (event) => {
  window.cart_data = event.detail["cart"];
});

/*
if(window.location.pathname == "/account" && window.location.href.indexOf("?") == -1){
  // account portal with no ? url params (eg. the default account view)
  waitForElement('.chContent-Body-Page').then(content => {
    waitForElement('[id*="proteus_bulk_order_quickbuy"]').then(bog_quickbuy => {
      content.insertAdjacentElement("afterbegin", bog_quickbuy);
    }).catch();
  }).catch();
}
*/

waitForElement('.variant-picker__option-values').then(variants_picker => {
  
  // preselect option L --> XL --> M --> S --> 2XL, if available
  let variant_L, variant_XL, variant_M, variant_S, variant_2XL;

  const select_label = (label) => {
    const label_input = document.getElementById(label.closest("label").getAttribute("for"));
    if (!label_input) return;

    label_input.checked = true;
    label_input.dispatchEvent(new Event('change', { bubbles: true }));

    setTimeout(() => {
      label_input.checked = true;
      label_input.dispatchEvent(new Event('change', { bubbles: true }));
    }, 1000);
  };

  if (window.location.href.indexOf("variant=") === -1) {
    observeSelector('label:not(.is-disabled) > span', label => {
      const text = label.innerText.trim();

      if (text === "L") variant_L = label;
      else if (text === "XL") variant_XL = label;
      else if (text === "M") variant_M = label;
      else if (text === "S") variant_S = label;
      else if (text === "2XL") variant_2XL = label;
    });

    // wait a moment to let observeSelector fill variables
    setTimeout(() => {
      if (variant_L) return select_label(variant_L);
      if (variant_XL) return select_label(variant_XL);
      if (variant_M) return select_label(variant_M);
      if (variant_S) return select_label(variant_S);
      if (variant_2XL) return select_label(variant_2XL);
    }, 10);
  }

}).catch();
 
// for bulk ATC form in /account
/*
if(window.location.href.indexOf("/account") > -1){
  observeSelector('.bulk-order-group-selector-visual .group-visual-selector', atc_form_option => {
    atc_form_option.addEventListener("click", () => {
      setTimeout(() => {
        let selected_option = document.querySelector('.group-visual-selector.active input');
        if(selected_option.id.indexOf('hooded-sweatshirt') > -1){
          window.product_lifetime_purchase_count = window.customer_data.lifetime_purchase_counts["Hooded Sweatshirt"];
          
        } else if(selected_option.id.indexOf('zip-up-sweatshirt') > -1){
          window.product_lifetime_purchase_count = window.customer_data.lifetime_purchase_counts["Zip Up Sweatshirt"];
          
        } else if(selected_option.id.indexOf('crewneck-sweatshirt') > -1){
          window.product_lifetime_purchase_count = window.customer_data.lifetime_purchase_counts["Crewneck Sweatshirt"];
          
        } else if(selected_option.id.indexOf('sweatpant') > -1){
          window.product_lifetime_purchase_count = window.customer_data.lifetime_purchase_counts["Sweatpant"];
          
        } else if(selected_option.id.indexOf('sweatshort') > -1){
          window.product_lifetime_purchase_count = window.customer_data.lifetime_purchase_counts["Sweatshort"];
          
        } else if(selected_option.id.indexOf('short-sleeve-t-shirt') > -1){
          window.product_lifetime_purchase_count = window.customer_data.lifetime_purchase_counts["Short Sleeve T-shirt"];
          
        } else if(selected_option.id.indexOf('long-sleeve-t-shirt') > -1){
          window.product_lifetime_purchase_count = window.customer_data.lifetime_purchase_counts["Long Sleeve T-shirt"];
          
        } else if(selected_option.id.indexOf('beanies') > -1){
          window.product_lifetime_purchase_count = window.customer_data.lifetime_purchase_counts["Headwear"];
          
        } 
      }, 200)
      
    })
  })
}
*/